export default __webpack_public_path__ + "static/media/rank-end-head.f58c481b.png";